import React from 'react';

interface ProgressBarProps {
   value: number;          // 0–100
   color?: string;         // tailwind bg class, e.g. 'bg-green-500'
   height?: string;        // tailwind h class, default 'h-1.5'
   className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
   value,
   color = 'bg-blue-500',
   height = 'h-1.5',
   className = '',
}) => (
   <div className={`w-full bg-gray-700 rounded-full overflow-hidden ${height} ${className}`}>
      <div
         className={`${height} rounded-full transition-all duration-500 ${color}`}
         style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
      />
   </div>
);

export default ProgressBar;
